import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "reportsFilterTriggerValuePipe",
    standalone: false
})
export class ReportsFilterTriggerValuePipe implements PipeTransform {
    transform(stringValue: string, count: number) {
        if (count === 1) {
            if (stringValue === "gradeLevels") {
                return "Level";
            } else {
                return stringValue;
            }
        } else if (count > 1) {
            if (stringValue === "proficiency") {
                return "Proficiencies";
            } else if (stringValue === "gradeLevels") {
                return "Levels";
            } else {
                return stringValue + "s";
            }
        }
    }
}
